import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'
import _imports_1 from '@/assets/img/management/add.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-2a8f900b")

_pushScopeId("data-v-2a8f900b")
const _hoisted_1 = { class: "genericPadding hasHeader bgWhite" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "fs_13 d-block ln_12 name" }
const _hoisted_7 = { class: "adminButtonContainer" }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeCallBack()))
      }, [
        _hoisted_3
      ]),
      _createVNode(_component_localized_text, {
        localizedKey: "app_gestiscicategorieallegati",
        text: "Gestisci Categorie Allegati",
        class: "fs_12 greyBlue"
      }),
      _hoisted_4
    ]),
    (_ctx.categoriesAllegati.length == 0 )
      ? (_openBlock(), _createBlock(_component_localized_text, {
          key: 0,
          localizedKey: "app_ancoranessunacategoria",
          text: "Ancora nessuna categoria",
          class: "fs_14 greyBlue d-block ln_12 text-center"
        }))
      : _createCommentVNode("", true),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categoriesAllegati, (cat) => {
      return (_openBlock(), _createBlock("div", {
        class: "d-flex align-items-center justify-content-between mb-3",
        key: cat.name
      }, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", null, [
            _createVNode("span", _hoisted_6, _toDisplayString(cat.name), 1)
          ])
        ]),
        _createVNode("button", {
          type: "button",
          class: "genericButton secondaryButton px-2",
          onClick: ($event: any) => (_ctx.deleteCategory(cat.id))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_eliminacat",
            text: "Elimina Categoria",
            class: "fs_13"
          })
        ], 8, ["onClick"])
      ]))
    }), 128)),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", {
        class: "managementButton",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addCategory()))
      }, [
        _hoisted_8
      ])
    ])
  ]))
})